{
    "Accessibility": {
        "SvgTitle": {
            "agentIndicator": "Indicador de agente",
            "botIndicator": "Indicador de bot",
            "chatIcon": "Icono de chat",
            "checkboxIcon": "Icono de casilla de verificación",
            "chevronDown": "Chevron hacia abajo",
            "chevronRight": "Chevron hacia la derecha",
            "clockIcon": "Icono de reloj",
            "closeIcon": "Icono de cerrar",
            "endChatIcon": "Icono de terminar chat",
            "feedbackIcon": "Icono de retroalimentación",
            "menuIcon": "Icono de menú",
            "muteIcon": "Icono de silenciar",
            "newMessageIcon": "Icono de mensaje nuevo",
            "radioIcon": "Icono de botón de opción",
            "ratingStarIcon": "Icono de estrella de calificación",
            "receiptIcon": "Icono de recibo",
            "ringIcon": "Icono de Ring",
            "sendIcon": "Icono de enviar",
            "themeIcon": "Icono de tema",
            "thumbsDownIcon": "Icono de pulgar hacia abajo",
            "thumbsUpIcon": "Icono de pulgar hacia arriba",
            "unmuteIcon": "Icono de activar sonido",
            "userIcon": "Icono de usuario"
        }
    },
    "Components": {
        "Alert": {
            "ariaLabel": "Cerrar",
            "endChatError": "Error al finalizar la sesión, inténtalo de nuevo",
            "sessionEnded": "La sesión finalizó. Se te redirigió a la página de inicio.",
            "networkError": "Se produjo un problema al conectar con tu sesión, inténtalo de nuevo",
            "messageError": "Lo sentimos, nuestro asistente de chat no está disponible en este momento. Utiliza <a href='https://ring.com/support'>Ring Help</a> para obtener recursos de ayuda o inténtalo de nuevo en unos minutos.",
            "messageLabel": "alerta",
            "pendingTimeout": "Lo sentimos, nuestro asistente está tardando más de lo esperado en responder. Por favor, inténtalo de nuevo o reformula tu pregunta."
        },
        "Body": {
            "latestMessage": "Mensajes más recientes",
            "loadMessages": "Cargar mensajes",
            "newMessage": "Nuevo mensaje",
            "title": "¿Cómo podemos ayudarte?",
            "subtitle": "¡Hola! Soy el asistente de Servicio de atención al cliente de Ring. ¿Cómo puedo ayudarte hoy?"
        },
        "Bubble": {
            "ariaLabel": "mensaje de chat",
            "eventsTitle": "Eventos recientes",
            "sourceTitle": "Enlaces útiles"
        },
        "Entry": {
            "reasoningAriaLabel": "Pensando",
            "reasonings": {
                "thinkingText": "Pensando"
            }
        },
        "Event": {
            "defaultJoin": "Un miembro del equipo de Ring se unió al chat en directo.",
            "customerJoin": "Transferido al chat en directo.",
            "agentJoin": "se unió al chat en directo.",
            "defaultLeft": "El miembro del equipo de Ring abandonó el chat en directo.",
            "customerLeft": "Abandonaste el chat.",
            "agentLeft": "abandonó el chat en directo.",
            "idle": "Has estado inactivo durante un tiempo. Avísanos si podemos ayudarte.",
            "idleContinue": "Sigo aquí, solo necesito más tiempo",
            "idleEnd": "Finalizar chat",
            "returned": "¡Bienvenido de nuevo! Continuemos con la conversación."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Me gusta",
            "ariaLabelThumbsDown": "No me gusta",
            "header": "¿Te resultó útil?",
            "sent": "Gracias por tus comentarios",
            "thumbsDown": "Lamento que mi respuesta no haya sido satisfactoria. Me encantaría recibir tus comentarios sobre cómo mejorar.",
            "thumbsDownResponse": "Gracias por tus comentarios. Intenta reformular tu pregunta.",
            "thumbsUp": "¡Me alegro de que te haya ayudado! Avísame si hay algo más en lo que pueda ayudarte.",
            "RESPONSE_UNCLEAR": "Respuesta poco clara",
            "ISSUE_UNRESOLVED": "No resolvió mi problema",
            "NOT_HELPFUL": "No es útil"
        },
        "Footer": {
            "ariaLabel": "Enviar",
            "placeholder": "Haz una pregunta breve…",
            "botText": "Este chatbot utiliza IA generativa para responder tus preguntas. Verifica toda la información importante proporcionada en estas respuestas antes de proceder."
        },
        "Header": {
            "ariaLabelMenu": "Menú más",
            "ariaLabelMinimize": "Minimizar",
            "badgeTitle": "BETA",
            "badgeDisabled": "Desconectado",
            "themeLabel": "Tema",
            "muteLabel": "Silenciar",
            "unmuteLabel": "Desilenciar",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Finalizar chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Cerrar",
            "ariaLabelOpen": "Abrir",
            "notification": "Nuevo mensaje",
            "expand": "Haz clic para expandir"
        },
        "WidgetIcon": {
            "ariaLabel": "Chat para soporte"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimizar",
            "button": "Iniciar chat",
            "title": "Gracias por comunicarte con Ring",
            "subtitleHtml": "Al continuar, aceptas los <a href='https://ring.com/terms'>Términos de servicio de Ring</a>. Es posible que se recopile y registre la información relacionada con este chat. Consulta nuestro <a href='https://ring.com/privacy-notice'>Aviso de privacidad</a> para obtener más información.",
            "loading": "Iniciando chat...",
            "error": "No se puede iniciar la sesión, inténtalo de nuevo",
            "messageLabel": "texto de bienvenida"
        }
    }
}